<template>
  <div class="offers">
    <offer
      class="offers__offer"
      v-for="(offer ,index) in offersStore"
      :key="index"
      :display-link="!!showDisplayMore(offer)"
      :index="index"
      :offer="offer"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Offer from '@/components/comparator/offers/Offer.vue';

export default {
  name: 'offers',
  components: {
    Offer,
  },
  computed: {
    ...mapGetters({
      projectSelected: 'projectStore/projectSelected',
      offersStore: 'offerStore/offers',
      offersLoading: 'offerStore/offersLoading',
    }),
  },
  methods: {
    showDisplayMore(offer) {
      return this.$helpers.offers.showMoverName(this.projectSelected, offer);
    },
  },
};
</script>

<style lang="scss" scoped>
.offers {
  margin-top: 20px;
  &__offer {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
